import { useState } from "react";
import { isYoutubeThumb, youtubeThumb } from "../utils/youtube-thumb";

// Shows the uploaded thumbnail if there is one, otherwise YouTube's own.
// maxresdefault doesn't exist for some older videos, so fall back to hqdefault.
const VideoThumb = ({ src, videoUrl, alt = "" }: { src?: string; videoUrl: string; alt?: string }) => {
  const initial = src || youtubeThumb(videoUrl);
  const [current, setCurrent] = useState(initial);
  return (
    <img
      src={current}
      alt={alt}
      loading="lazy"
      onError={() => {
        if (isYoutubeThumb(current) && current.endsWith("maxresdefault.jpg")) setCurrent(youtubeThumb(videoUrl, "hqdefault"));
      }}
    />
  );
};

export default VideoThumb;
